import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  font-size: 14px;
`
export const IconContainer = styled.div`
  margin-right: 6px;
`
